<div class="mobile-template">
  <kendo-grid [data]="gridView$ | async" (cellClick)="onCellClick($event)"  [sortable]="sortSettings" [selectable]="selectSettings" [sort]="sort" (sortChange)="sortChange($event)" (selectionChange)="onSelectionChange($event)" [kendoGridSelectBy]="'id'" [(selectedKeys)]="gridSelectedKeys" class="pointer">
    <ng-template kendoGridToolbarTemplate>
      <input
        [placeholder]="'circ_search_input' | i18n"
        kendoTextBox
        (input)="onFilter($event.target.value)"
        style="width: auto;"
      />
    </ng-template>
    <!-- Mobile Template -->
    <kendo-grid-checkbox-column [showSelectAll]="true" *ngIf="enableSelect"></kendo-grid-checkbox-column>
    <kendo-grid-column [title]="'task.grid.circulation' | i18n">
      <ng-template kendoGridCellTemplate let-x>
        <h4>{{ x.title }}</h4>
        <div>{{ x.dueDate | i18nDate: { date: "medium" } }}</div>
        <div>{{ x.status | i18nCircStatus }}</div>
      </ng-template>
    </kendo-grid-column>
  </kendo-grid>
</div>

<div class="desktop-template">
  <kendo-grid (cellClick)="onCellClick($event)" [data]="gridView$ | async" [sortable]="sortSettings" [selectable]="selectSettings" [sort]="sort" (sortChange)="sortChange($event)" (selectionChange)="onSelectionChange($event)" [kendoGridSelectBy]="'id'" [(selectedKeys)]="gridSelectedKeys" class="pointer">
    <ng-template kendoGridToolbarTemplate>
      <input
        [placeholder]="'circ_search_input' | i18n"
        kendoTextBox
        (input)="onFilter($event.target.value)"
        style="width: auto;"
      />
    </ng-template>
    <kendo-grid-checkbox-column [showSelectAll]="true" *ngIf="enableSelect"></kendo-grid-checkbox-column>
    <kendo-grid-column [title]="'grid_title' | i18n" field="title" [filterable]="true">
      <ng-template kendoGridCellTemplate let-x>
        <span class="nobr">{{ x.title }}</span>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column [title]="'grid_dueDate' | i18n" field="dueDate">
      <ng-template kendoGridCellTemplate let-x>
        <span class="nobr">{{ x.dueDate | i18nDate: { date: "medium" } }}</span>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column *ngIf="showOutcome"  [title]="'grid_outcome' | i18n" field="outcome" >
      <ng-template kendoGridCellTemplate let-x>
        <span class="nobr">{{ x.outcome | i18nCircStatus }}</span>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column [title]="'grid_description' | i18n">
      <ng-template kendoGridCellTemplate let-x>
        {{ x.payload?.demand.length > 75 ? (x.payload?.demand | slice:0:75) + "..." : x.payload?.demand  }}
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-messages [noRecords]="'kendo_noRecords' | i18n">
    </kendo-grid-messages>
  </kendo-grid>
</div>
